import { FIELD_TYPES, ACCENT } from "../../../../constants/formflow/fieldTypes";
import { roleColor } from "../../../../utils/formflow/helpers";

export function FieldOverlay({ field, roles, isSelected, onMouseDown, activeType }) {
  const c = roleColor(roles, field.roleId);
  const ft = FIELD_TYPES.find((t) => t.id === field.type);

  return (
    <div
      onMouseDown={(e) => onMouseDown(e, field.id)}
      className="absolute flex select-none overflow-hidden transition-shadow duration-150"
      style={{
        left: `${field.x}%`,
        top: `${field.y}%`,
        width: `${field.w}%`,
        height: `${field.h}%`,
        background: c.bg,
        border: `${isSelected ? 2 : 1}px solid ${c.border}`,
        borderRadius: 4,
        cursor: activeType ? "crosshair" : "move",
        boxShadow: isSelected ? `0 0 0 3px ${c.border}44` : "none",
        zIndex: isSelected ? 10 : 1,
      }}
    >
      {field.type === "checkbox" ? (
        <div className="w-3.5 h-3.5 rounded-sm" style={{ border: `2px solid ${c.border}` }} />
      ) : (
        <div className="flex justify-center items-center gap-1.5 p-2 w-full overflow-hidden">
          {ft ? <ft.Icon size={11} color={c.text} className="shrink-0" /> : <></>}
          <span className="text-[11px] font-semibold whitespace-nowrap overflow-hidden text-ellipsis" style={{ color: c.text }}>
            {field.label}
          </span>
          {field.required ? (
            <span className="text-lg shrink-0" style={{ color: ACCENT }}>
              *
            </span>
          ) : (
            <></>
          )}
        </div>
      )}
      {/* <div className="absolute top-0.5 right-0.5 w-1.5 h-1.5 rounded-full" style={{ background: c.dot }} /> */}
    </div>
  );
}
